import { CATEGORY_IDS } from 'constants/categories'
import { CLOTHING_CATEGORY_SLUG } from 'constants/quickFilter'
import { useObserver } from 'mobx-react-lite'
import { useUserStore } from 'store/context'
import { useCategoryStore } from 'store/sidecar/ProductStreamContext'

export const useIsCategoryClothing = () => {
  const categoryStore = useCategoryStore()
  const gender = useUserStore(store => store.gender)
  const isCategoryClothing = useObserver(() => {
    const categoryId = CATEGORY_IDS[gender][CLOTHING_CATEGORY_SLUG]

    if (!categoryId || Array.isArray(categoryId)) {
      return false
    }

    return categoryStore.selectedIds.includes(categoryId)
  })
  return isCategoryClothing
}
